// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productActionsStyle } from "@ces/App/Components/Product/ProductActions";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { hideElement, xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

productActionsStyle.addToCartContainer = {
    css: css`
        display: flex;
        gap: 8px;
        align-items: center;
        min-width: 237px;
        ${xScreen("lte", "xs")} {
            flex-wrap: wrap;
        }
    `,
};

productActionsStyle.addToCartButtonWrapper = {
    css: css`
        flex: 1 0 auto;
    `,
};

productActionsStyle.productAddToCartButtonStyles = {
    mergeCss: true,
    typographyProps: {
        weight: fontConfig.weight.bold,
    },
    css: css`
        min-height: 33px;
        width: 100%;
        padding: 0 10px;
    `,
};

productActionsStyle.productUnitOfMeasureSelectStyles = {
    mergeCss: true,
    sizeVariant: "small",
    css: css`
        min-height: 33px;
        width: 84px;
        min-width: 84px;
    `,
};

productActionsStyle.productQuantityOrderedStyles = {
    wrapper: {
        css: css`
            width: 116px;
            min-width: 116px;
            min-height: 33px;
        `,
    },
};

productActionsStyle.productUomWrapper = {
    css: css`
        &:empty {
            ${hideElement}
        }
    `,
};
